// FC246/1276. TSV is deliberately strict and never guesses a print/finish.
export const BULK_PENDING_STORAGE_KEY = "trainer_quick_bulk_pending_v1";
export const BULK_COLUMNS = "Name and number\tSet\tFinish\tQuantity\tCatalogue ID (optional)\tPhoto reference (optional)";

export const parseQuickBulkTsv = (input) => {
  const lines = String(input || "").split(/\r?\n/).filter((line) => line.trim());
  if (lines.length && /^name(?: and number|_and_number)?\t/i.test(lines[0])) lines.shift();
  return lines.map((line, index) => {
    const fields = line.split("\t").map((value) => value.trim());
    return {
      index,
      name_and_number: fields[0] || "",
      set_name: fields[1] || "",
      card_variant: fields[2] || "",
      quantity: fields[3] || "",
      catalog_card_id: fields[4] || "",
      source_reference: fields[5] || "",
      // Invalid TSV widths are represented as review entries, never silently discarded.
      parse_error: fields.length < 4 || fields.length > 6
        ? "Expected 4–6 tab-separated columns; use tabs, not commas" : "",
    };
  });
};

export const bulkRowsToTsv = (rows) => rows.map((row) => [
  row.name_and_number, row.set_name, row.card_variant, row.quantity,
  row.catalog_card_id || "", row.source_reference || "",
].join("\t")).join("\n");

export const makeBulkOperationId = () => {
  const uuid = typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
    ? crypto.randomUUID().replace(/-/g, "")
    : Array.from({ length: 32 }, () => Math.floor(Math.random() * 16).toString(16)).join("");
  return `bulk-${uuid}`;
};

export const validBulkOperationId = (value) => /^bulk-[0-9a-f]{32}$/.test(value || "");

export const buildBulkCommitRows = (items, previewItems, approvedIndices, details) => {
  const byIndex = new Map(previewItems.map((item) => [item.index, item]));
  return items.filter((_, index) => approvedIndices.includes(index)).map((row) => {
    const preview = byIndex.get(row.index);
    if (preview?.status !== "matched" || !preview.match?.id) {
      throw new Error(`Row ${row.index + 1} has no validated exact card match`);
    }
    return {
      catalog_card_id: Number(preview.match.id),
      name_and_number: preview.match.name_and_number,
      set_name: preview.match.set_name,
      card_variant: row.card_variant,
      card_condition: "Near Mint",
      quantity: Number(row.quantity),
      inventory_apply_mode: "stage",
      single_allocation_quantity: 0,
      playset_allocation_quantity: 0,
      source_type: details.sourceType || "bulk_lot",
      unit_cost: String(details.unitCost),
      source_reference: row.source_reference || details.sourceReference.trim() || null,
      storage_location: details.storageLocation.trim() || null,
      notes: details.notes.trim() || null,
    };
  });
};

export const readPendingQuickBulk = () => {
  try {
    const stored = JSON.parse(window.localStorage.getItem(BULK_PENDING_STORAGE_KEY) || "null");
    return validBulkOperationId(stored?.payload?.operation_id) &&
      Number.isInteger(Number(stored.batchId)) && Number(stored.batchId) > 0 &&
      Array.isArray(stored.payload.rows) && stored.payload.rows.length > 0 ? stored : null;
  } catch (_) { return null; }
};

export const persistPendingQuickBulk = (pending) => {
  try {
    if (pending) window.localStorage.setItem(BULK_PENDING_STORAGE_KEY, JSON.stringify(pending));
    else window.localStorage.removeItem(BULK_PENDING_STORAGE_KEY);
  } catch (_) { /* In-memory retry remains available. */ }
};
